// extracted by mini-css-extract-plugin
module.exports = {"WarningText":"DeleteTemplateModal_WarningText__vY7ZL"};